// extracted by mini-css-extract-plugin
export default {"action":"Action_action__MWb2X","expanded":"Action_expanded__oB+Cp","disabled":"Action_disabled__whZZN","img":"Action_img__Lg7iZ","title":"Action_title__MyHZS"};